import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import store from "../store";
import { isMobileDevice } from "@/utils/index";

import Exchange from "../views/Exchange.vue";
import Markets from "../views/Markets.vue";
import Lock from "../views/Lock.vue";
import Login from "../views/Login.vue";
import NewsDetails from "../views/NewsDetails.vue";
import Notfound from "../views/Notfound.vue";
import OtpNumber from "../views/OtpNumber.vue";
import OtpVerify from "../views/OtpVerify.vue";
import Profile from "../views/Profile.vue";
import Reset from "../views/Reset.vue";
import Settings from "../views/Settings.vue";
import Signup from "../views/Signup.vue";
import TermsAndConditions from "../views/TermsAndConditions.vue";
import Wallet from "../views/Wallet.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Exchange",
    component: Exchange,
  },
  {
    path: "/markets",
    name: "Markets",
    component: Markets,
  },
  {
    path: "/lock",
    name: "Lock",
    component: Lock,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/news-details",
    name: "NewsDetails",
    component: NewsDetails,
  },
  {
    path: "/404",
    name: "Notfound",
    component: Notfound,
  },
  {
    path: "/otp-number",
    name: "OtpNumber",
    component: OtpNumber,
  },
  {
    path: "/otp-verify",
    name: "OtpVerify",
    component: OtpVerify,
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
  },
  {
    path: "/reset",
    name: "Reset",
    component: Reset,
  },
  {
    path: "/settings",
    name: "Settings",
    component: Settings,
  },
  {
    path: "/sign-up",
    name: "Signup",
    component: Signup,
  },
  {
    path: "/terms-and-conditions",
    name: "TermsAndConditions",
    component: TermsAndConditions,
  },
  {
    path: "/wallet",
    name: "Wallet",
    component: Wallet,
  },
  {
    path: "/notice-list",
    name: "NoticeList",
    component: () => import("@/views/Notice-list.vue"),
  },
  {
    path: "/notice/:id",
    name: "NoticeDetails",
    component: () => import("@/views/Notice-details.vue"),
  },
  {
    path: "/user",
    name: "User",
    component: () => import("@/views/User/index.vue"),
    children: [
      {
        path: "profile",
        name: "Profile",
        component: () => import("@/views/User/child/Profile.vue"),
      },
      {
        path: "wallet",
        name: "Wallet",
        component: () => import("@/views/User/child/Wallet.vue"),
      },
      {
        path: "settings",
        name: "Settings",
        component: () => import("@/views/User/child/Settings.vue"),
      },
      {
        path: "deposit",
        name: "Deposit",
        component: () => import("@/views/User/child/Deposit.vue"),
      },
      {
        path: "withdraw",
        name: "Withdraw",
        component: () => import("@/views/User/child/Withdraw.vue"),
      },
      {
        path: "account-records",
        name: "AccountRecords",
        component: () => import("@/views/User/child/AccountRecords.vue"),
      },
      {
        path: "trading-records",
        name: "TradingRecords",
        component: () => import("@/views/User/child/TradingRecords.vue"),
      },
      {
        path: "deposit-detail",
        name: "DepositDetail",
        component: () => import("@/views/User/child/DepositDetail.vue"),
      },
      {
        path: "withdrawal-detail",
        name: "WithdrawalDetail",
        component: () => import("@/views/User/child/WithdrawalDetail.vue"),
      },
      {
        path: "wallet-address",
        name: "WalletAddress",
        component: () => import("@/views/User/child/WalletAddress.vue"),
      },
      {
        path: "add-wallet-address",
        name: "AddWalletAddress",
        component: () => import("@/views/User/child/AddWalletAddress.vue"),
      },
      {
        path: "add-bank-card",
        name: "AddBankCard",
        component: () => import("@/views/User/child/AddBankCard.vue"),
      },
    ],
  },
];
if (isMobileDevice()) {
  routes[0].component = () => import("@/views/mobile.vue");
  routes[0].redirect = "/trade";
  routes[0].children = [
    {
      path: "/list",
      name: "List",
      component: () => import("@/views/Mobile/list.vue"),
    },
    {
      path: "/orders",
      name: "Orders",
      component: () => import("@/views/Mobile/orders.vue"),
    },
    {
      path: "/trade",
      name: "Trade",
      component: () => import("@/views/Mobile/trade.vue"),
    },
    {
      path: "/news",
      name: "News",
      component: () => import("@/views/Mobile/news.vue"),
    },
    {
      path: "/mine",
      name: "Mine",
      component: () => import("@/views/Mobile/mine.vue"),
      redirect: "/mine/mobileProfile",
      children: [
        {
          path: "mobileProfile",
          name: "MineProfile",
          component: () => import("@/views/User/child/mobileProfile.vue"),
        },
        {
          path: "wallet",
          name: "MineWallet",
          component: () => import("@/views/User/child/Wallet.vue"),
        },
        {
          path: "settings",
          name: "MineSettings",
          component: () => import("@/views/User/child/Settings.vue"),
        },
        {
          path: "deposit",
          name: "MineDeposit",
          component: () => import("@/views/User/child/Deposit.vue"),
        },
        {
          path: "withdraw",
          name: "MineWithdraw",
          component: () => import("@/views/User/child/Withdraw.vue"),
        },
        {
          path: "account-records",
          name: "MineAccountRecords",
          component: () => import("@/views/User/child/AccountRecords.vue"),
        },
        {
          path: "trading-records",
          name: "MineTradingRecords",
          component: () => import("@/views/User/child/TradingRecords.vue"),
        },
        {
          path: "deposit-detail",
          name: "MineDepositDetail",
          component: () => import("@/views/User/child/DepositDetail.vue"),
        },
        {
          path: "withdrawal-detail",
          name: "MineWithdrawalDetail",
          component: () => import("@/views/User/child/WithdrawalDetail.vue"),
        },
        {
          path: "wallet-address",
          name: "MineWalletAddress",
          component: () => import("@/views/User/child/WalletAddress.vue"),
        },
        {
          path: "add-wallet-address",
          name: "MineAddWalletAddress",
          component: () => import("@/views/User/child/AddWalletAddress.vue"),
        },
        {
          path: "add-bank-card",
          name: "MineAddBankCard",
          component: () => import("@/views/User/child/AddBankCard.vue"),
        },
        {
          path: "userPwd",
          name: "MineAddBankCard",
          component: () => import("@/views/User/child/userPwd.vue"),
        }
      ],
    },
  ];
}

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

const whiteList: string[] = ["/login", "/sign-up", "/list", "/trade", "/news"];

if (isMobileDevice()) {
  router.beforeEach((to, from, next) => {
    if (
      !store.state.isLogin &&
      !whiteList.includes(to.path) &&
      isMobileDevice()
    ) {
      return next("/login");
    }
    next();
  });
}

// function isMobileDevice() {
//   return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
//     navigator.userAgent
//   );
// }

// router.beforeEach((to, from, next) => {
//   if (
//     !store.state.isLogin &&
//     !whiteList.includes(to.path) &&
//     isMobileDevice()
//   ) {
//     return next("/login");
//   }
//   next();
// });

export default router;
